export const AVATAR_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/heic']

export const EVENT_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/webp']